export const getValidValue = (...values) => {
    for (let value of values) {
        if (
            value && // Check if the value is truthy
            typeof value !== 'boolean' && // Exclude boolean false
            typeof value !== 'number' && // Exclude 0
            typeof value.toLowerCase === 'function' && // Ensure the value is a string-like object
            value.toLowerCase() !== "null" &&
            value.toLowerCase() !== "undefined" &&
            value.trim() !== "" // Ensure the value is not an empty string
        ) {
            return value;
        } else if (typeof value === 'number' && !isNaN(value)) {
            // Return valid numbers
            return value;
        }
    }
    return "N/A";
};

export const getValidValueReturnNull = (...values) => {
    for (let value of values) {
        if (
            value && // Check if the value is truthy
            typeof value !== 'boolean' && // Exclude boolean false
            typeof value !== 'number' && // Exclude 0
            typeof value.toLowerCase === 'function' && // Ensure the value is a string-like object
            value.toLowerCase() !== "null" &&
            value.toLowerCase() !== "undefined" &&
            value.trim() !== "" // Ensure the value is not an empty string
        ) {
            return value;
        } else if (typeof value === 'number' && !isNaN(value)) {
            // Return valid numbers
            return value;
        }
    }
    return null;
};
